import { NO_END, addDays, diffDay, dateToTimestamp } from '@ha/date';

import {
  DateFlexibility,
  ShortRangeRentThreshold,
  MULTIUSE_END,
} from '../constants';
import { FilterBuilder } from '../Types';

const dateToTSBuilder: FilterBuilder = (
  { startDate, endDate, advertiserId },
  context,
) => {
  if ((!startDate && !endDate && advertiserId) || context?.withNewDateFilter) {
    return '';
  }

  const isShortRange = Boolean(
    startDate &&
      endDate &&
      diffDay(endDate, startDate) <= ShortRangeRentThreshold,
  );

  // eslint-disable-next-line no-nested-ternary
  const end = endDate
    ? isShortRange
      ? endDate // do not add flexible dates if user is searching for a short period
      : addDays(endDate, -DateFlexibility)
    : // If there is no end date specified, but there is a start date specified,
      // then the endDate should be greater than the startDate.
      startDate;

  const endDateTS = end ? dateToTimestamp(new Date(end)) : '';
  const noEndDateTS = dateToTimestamp(new Date(NO_END));
  const multiuseEndDateTS = dateToTimestamp(new Date(MULTIUSE_END));

  if (endDateTS) {
    return `(dateToTS>=${endDateTS} OR dateToTS=${noEndDateTS} OR dateToTS=${multiuseEndDateTS})`;
  }

  return '';
};

export default dateToTSBuilder;
